import React from 'react'
import { connect } from 'react-redux'
import { change, Field, getFormValues, reduxForm } from 'redux-form'
import { Container } from './styled'
import { useNavigate,useParams } from "react-router-dom";
import TextInput from 'components/TailwindForm/TextInput'
import StandardButton from 'components/Shareds/StandardButton'
// import { userLogIn } from 'ducks/authenticate';
// import { resetPasswordPath } from 'routes';
import { loginRequest } from 'core/authConfig'
import LabelOnly from 'components/TailwindForm/LabelOnly';
import { getTextResult, textKey } from 'core/textResult'
import { toastClear } from 'ducks/app';

const Login = (props) => {
    const { valueForm, userLogIn, accessToken, user,toastClear } = props
    const history = useNavigate()
    const { id } = useParams()
    React.useEffect(() => {
        toastClear(""); 
        if (!localStorage.getItem('language')) {
          localStorage.setItem('language', "en");
        }
      
      }, [])

    return (
        <Container className='App h-full'>
            <div className="flex flex-col items-center justify-center ">
                {/* Icon */}
                <div className="">
                    {/* ใส่รูปไอคอนตรงนี้ */}
                    <img src="/Completed.svg" alt="Success Icon" className="w-16 h-16 lg:w-32 lg:h-32" />
                </div>

                {/* Title */}
                <h1 className="text-2xl font-bold mb-2">{getTextResult(textKey.SUCCESS1)}</h1>

                {/* Reference Number */}
                <p className="text-gray-700 mb-6">{getTextResult(textKey.SUCCESS2)}<span className="font-semibold ml-2">{id}</span></p>

                {/* Contact Us Section */}
                <div className="text-center">
                    <h2 className="text-lg font-semibold mb-4">{getTextResult(textKey.SUCCESS3)}</h2>

                    {/* Phone Contact */}
                    <div className="flex items-center justify-center mb-2">
                        <img src="/icon-phone.png" alt="Phone Icon" className="w-5 h-5 mr-2" />
                        <p className="text-gray-700">02-088-6400 Ext. 220 (CSO Office)</p>
                    </div>

                    {/* Email Contacts */}
                    <div className="flex items-center justify-center mb-2">
                        <img src="/icon-mail.png" alt="Email Icon" className="w-5 h-5 mr-2" />
                        <p className="text-gray-700">whistleblower_bod@dtgo.com</p>
                    </div>
                    <div className="flex items-center justify-center">
                        <img src="/icon-mail.png" alt="Email Icon" className="w-5 h-5 mr-2" />
                        <p className="text-gray-700">whistleblower_cso@dtgo.com</p>
                    </div>
                </div>
            </div>


        </Container>

    )
}


const mapStateToProps = (state) => {
    return {
        valueForm: getFormValues('formLogin')(state),
        // user: state.authenticate.user,
        // accessToken: state.authenticate.user.accessToken,

    }
}

const mapDispatchToProps = {
    // userLogIn,
    toastClear

}
const LoginForm = reduxForm({
    form: 'formLogin',
    enableReinitialize: true,
})(Login)

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm)

